export default {
  title: 'Yritystiedot',
  form: {},
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    success: 'Tietosi tallennettiin onnistuneesti.',
  },
};
